import { EstadoNoContratado } from '../../componentes/EstadoPagina';

/**
 * «No contratado» de Entradas, Taquilla e Informes sin el bloque «Entradas y eventos» (10.6 a 10.8, G778): el nombre del
 * bloque como en 0.1 con `?bloques=sin-eventos` y el texto de 10.6 (al Propietario, lo que cuesta; a los demás, que se lo
 * pidan). «Añadir a mi plan» lleva a Plan con el bloque resaltado (G120).
 */
export function EntradasNoContratado({ propietario, navegar, movil }: { propietario: boolean; navegar: (ruta: string) => void; movil: boolean }) {
    return (
        <EstadoNoContratado
            bloque="Entradas y eventos"
            texto={propietario
                ? 'Sin cuota: el comprador paga 1 € + 1,5 % por entrada. Con él vendes por la web, el widget, el chat y la taquilla.'
                : 'Pídele al propietario que lo active: no tiene cuota.'}
            incluye={[]}
            propietario={propietario}
            onAnadir={propietario ? () => { navegar('/plan?block=entradas_eventos'); } : null}
            onInicio={() => { navegar('/'); }}
            movil={movil}
        />
    );
}
